import { uuidProfileIdSchema } from "../protocol/profile.js";
import { spaceFileDescriptorSchema } from "./space-files.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/space-message-pins.ts
const spaceFilePinMutationSchema = z$1.strictObject({
	fileId: z$1.string().trim().min(1).max(200),
	action: z$1.enum(["pin", "unpin"])
});
const spaceFilePinsResponseSchema = z$1.strictObject({ pins: z$1.array(z$1.strictObject({
	file: spaceFileDescriptorSchema,
	pinnedByProfileId: uuidProfileIdSchema,
	pinnedByName: z$1.string(),
	pinnedAt: z$1.string()
})) });
const spaceMessagePinMutationSchema = z$1.strictObject({
	signalId: z$1.string().trim().min(1).max(200),
	action: z$1.enum(["pin", "unpin"])
});
const spaceMessagePinsResponseSchema = z$1.strictObject({ pins: z$1.array(z$1.strictObject({
	signalId: z$1.string().min(1),
	pinnedByProfileId: uuidProfileIdSchema,
	pinnedByName: z$1.string(),
	pinnedAt: z$1.string(),
	authorName: z$1.string(),
	preview: z$1.string()
})) });
//#endregion
export { spaceFilePinMutationSchema, spaceFilePinsResponseSchema, spaceMessagePinMutationSchema, spaceMessagePinsResponseSchema };

//# sourceMappingURL=space-message-pins.js.map